import React, { Component } from 'react'
import PropTypes from 'prop-types';
import { IndexLink, Link } from 'react-router';

class PageLink extends Component {
    static contextTypes = {
        router: PropTypes.object.isRequired
    };

    constructor(props) {
        super(props);

        this.state = {
            useHash: false
        }

        if (this.props.to.toLowerCase().indexOf("https://") !== -1 || this.props.to.toLowerCase().indexOf("http://") !== -1) {
            this.state.useHash = true;
        } else {
            if (this.props.to.indexOf('#') !== -1) {
                if (this.props.to.toLowerCase().indexOf(window.location.pathname.toLowerCase() + '#') === 0) {
                    this.state.useHash = true;
                }
            }
        }

    }

    render() {
        return (
            <span>
                {
                    this.state.useHash === true ?
                        <a href={this.props.to}>
                            <span>{this.props.text}</span>
                        </a> :
                        <Link to={this.props.to}>{this.props.text}</Link>
                }
            </span>
        );
    }
}

export default PageLink


// WEBPACK FOOTER //
// ./src/components/Page/PageLink.js